import { Loader } from "./loader";

export { Loader };
export default Loader;
